{
  "actions": {
    "add": "Add",
    "open": "Open",
    "openType": "Open {{type, lowercase}}",
    "edit": "Edit",
    "remove": "Remove",
    "abort": "Cancel",
    "close": "Close",
    "clear": "Clear",
    "create": "Create",
    "createNew": "Create new {{documentType}}",
    "search": "Search",
    "sort": "Sort",
    "sortBy": "Sort by {{label}}",
    "presetSort": "Preset sorting",
    "grouping": "Choose grouping",
    "nogrouping": "No grouping",
    "group": "Group",
    "copy": "Copy",
    "confirm": "Done",
    "markAsDone": "Mark as done",
    "move": "Move",
    "yes": "Yes",
    "no": "No",
    "approve": "Approve",
    "saveType": "Save {{type}}",
    "save": "Save",
    "publish": "Publish"
  },
  "misc": {
    "unknown": "unknown",
    "user": "user",
    "numberOf": "Number of",
    "from": "From",
    "new": "New",
    "selected": "selected",
    "since": "since",
    "missing": "missing",
    "loading": "Loading...",
    "titleMissing": "Title missing",
    "fetchingSession": "Fetching session...",
    "fetchingUserData": "Fetching user data...",
    "headingAndContent": "Heading and content",
    "markedAsCancelled": "Marked as cancelled",
    "error": "Error",
    "selectTime": "Select time",
    "selectDates": "Select dates",
    "searching": "Searching...",
    "nothingFound": "Nothing found"
  },
  "advancedSearch": {
    "title": "Advanced Search",
    "structured": "Structured",
    "querySyntax": "Query syntax",
    "query": "Query",
    "searchIn": "Search in",
    "matchType": "Match type",
    "words": "Words",
    "exactPhrase": "Exact phrase",
    "requireAllTerms": "Require all terms (AND)",
    "fuzzyMatching": "Fuzzy matching",
    "fuzzyAuto": "Auto",
    "fuzzyEdit1": "~1 edit",
    "fuzzyEdit2": "~2 edits",
    "prefixLength": "Lock first N chars",
    "boost": "Relevance boost",
    "dateRange": "Date range",
    "fieldExists": "Field exists/missing",
    "exists": "Has",
    "missing": "Missing",
    "moreOptions": "More options",
    "cancel": "Cancel",
    "search": "Search",
    "searchTerms": "Search terms...",
    "namePlaceholder": "Name this search (optional)",
    "querySyntaxPlaceholder": "title:\"ukraine\" AND content:crisis*",
    "syntaxReference": "Syntax reference",
    "syntaxOperators": "Operators",
    "syntaxOperatorsValue": "AND, OR, NOT",
    "syntaxPhrase": "Phrase",
    "syntaxPhraseValue": "\"exact phrase\"",
    "syntaxWildcard": "Wildcard",
    "syntaxWildcardValue": "ukrai* , cr?sis",
    "syntaxFuzzy": "Fuzzy",
    "syntaxFuzzyValue": "word~2",
    "syntaxGrouping": "Grouping",
    "syntaxGroupingValue": "(a OR b) AND c",
    "syntaxFieldSearch": "Field search",
    "syntaxFieldSearchValue": "field:value",
    "syntaxAvailableFields": "Available fields",
    "hints": {
      "searchIn": "Choose which document fields to search in",
      "words": "Finds the best matching field for your search terms",
      "exactPhrase": "Requires words to appear in exact order",
      "requireAllTerms": "All search terms must be present (default is any term)",
      "fuzzyMatching": "Allows approximate matches, e.g. typos or misspellings",
      "fuzzyDisabledForPhrase": "Fuzzy matching is not available for exact phrase searches",
      "fuzzyEdits": "Number of character changes allowed per word",
      "prefixLength": "Number of starting characters that must match exactly before fuzzy kicks in",
      "boost": "Multiplier for relevance scoring — higher values rank matches higher",
      "fieldExists": "Filter documents by whether a field has content or is empty",
      "searchInDisabledForMissing": "Cannot search a field that is required to be missing"
    },
    "notices": {
      "dateRangeNotConverted": "The date range is not part of the query string and will not be used."
    },
    "modeChange": {
      "title": "Change search mode?",
      "description": "The query string cannot be shown in the form. Changing mode discards it and starts a new, empty search. The search already applied is not affected.",
      "confirm": "Change mode"
    },
    "badge": {
      "fuzzy": "Fuzzy (~{{edits}})",
      "fuzzyAuto": "Fuzzy (auto)",
      "fields": "Fields: {{fields}}",
      "boost": "Boost: {{boost}}x"
    },
    "fields": {
      "title": "Title",
      "content": "Content",
      "slugline": "Slugline",
      "description": "Description",
      "assignment": "Assignment",
      "subject": "Subject",
      "table": "Table"
    }
  }
}
